import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { array, isArray, stringValue } from 'vega-util';
import { vgField } from '../channeldef';
import { isExprRef } from '../expr';
import { isText } from '../title';
import { deepEqual, getFirstDefined } from '../util';
import { isSignalRef } from '../vega.schema';
export var BIN_RANGE_DELIMITER = " \u2013 ";
export function signalOrValueRefWithCondition(val) {
  var condition = isArray(val.condition) ? val.condition.map(conditionalSignalRefOrValue) : conditionalSignalRefOrValue(val.condition);
  return Object.assign(Object.assign({}, signalRefOrValue(val)), {
    condition: condition
  });
}
export function signalRefOrValue(value) {
  if (isExprRef(value)) {
    var expr = value.expr,
        rest = __rest(value, ["expr"]);

    return Object.assign({
      signal: expr
    }, rest);
  }

  return value;
}
export function conditionalSignalRefOrValue(value) {
  if (isExprRef(value)) {
    var expr = value.expr,
        rest = __rest(value, ["expr"]);

    return Object.assign({
      signal: expr
    }, rest);
  }

  return value;
}
export function signalOrValueRef(value) {
  if (isExprRef(value)) {
    var expr = value.expr,
        rest = __rest(value, ["expr"]);

    return Object.assign({
      signal: expr
    }, rest);
  }

  if (isSignalRef(value)) {
    return value;
  }

  return value !== undefined ? {
    value: value
  } : undefined;
}
export function exprFromValueOrSignalRef(ref) {
  if (isSignalRef(ref)) {
    return ref.signal;
  }

  return stringValue(ref.value);
}
export function signalOrStringValue(v) {
  if (isSignalRef(v)) {
    return v.signal;
  }

  return v == null ? null : stringValue(v);
}
export function applyMarkConfig(e, model, propsList) {
  var _iterator = _createForOfIteratorHelper(propsList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;
      var value = getMarkConfig(property, model.markDef, model.config);

      if (value !== undefined) {
        e[property] = signalOrValueRef(value);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return e;
}
export function getStyles(mark) {
  var _a;

  return [].concat(mark.type, (_a = mark.style) !== null && _a !== void 0 ? _a : []);
}
export function getMarkPropOrConfig(channel, mark, config) {
  var opt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var vgChannel = opt.vgChannel,
      ignoreVgConfig = opt.ignoreVgConfig;

  if (vgChannel && mark[vgChannel] !== undefined) {
    return mark[vgChannel];
  } else if (mark[channel] !== undefined) {
    return mark[channel];
  } else if (ignoreVgConfig && (!vgChannel || vgChannel === channel)) {
    return undefined;
  }

  return getMarkConfig(channel, mark, config, opt);
}
/**
 * Return property value from style or mark specific config property if exists.
 * Otherwise, return general mark specific config.
 */

export function getMarkConfig(channel, mark, config) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      vgChannel = _ref.vgChannel;

  return getFirstDefined( // style config has highest precedence
  vgChannel ? getMarkStyleConfig(channel, mark, config.style) : undefined, getMarkStyleConfig(channel, mark, config.style), // then mark-specific config
  vgChannel ? config[mark.type][vgChannel] : undefined, config[mark.type][channel], // Need to cast because MarkDef doesn't perfectly match with AnyMarkConfig, but if the type isn't available, we'll get nothing here, which is fine
  // If there is vgChannel, skip vl channel.
  // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
  vgChannel ? config.mark[vgChannel] : config.mark[channel] // Need to cast for the same reason as above
  );
}
export function getMarkStyleConfig(prop, mark, styleConfigIndex) {
  return getStyleConfig(prop, getStyles(mark), styleConfigIndex);
}
export function getStyleConfig(p, styles, styleConfigIndex) {
  styles = array(styles);
  var value;

  var _iterator2 = _createForOfIteratorHelper(styles),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var style = _step2.value;
      var styleConfig = styleConfigIndex[style];

      if (styleConfig && styleConfig[p] !== undefined) {
        value = styleConfig[p];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return value;
}
/**
 * Return Vega sort parameters (tuple of field and order).
 */

export function sortParams(orderDef, fieldRefOption) {
  return array(orderDef).reduce(function (s, orderChannelDef) {
    var _a;

    s.field.push(vgField(orderChannelDef, fieldRefOption));
    s.order.push((_a = orderChannelDef.sort) !== null && _a !== void 0 ? _a : 'ascending');
    return s;
  }, {
    field: [],
    order: []
  });
}
export function mergeTitleFieldDefs(f1, f2) {
  var merged = _toConsumableArray(f1);

  f2.forEach(function (fdToMerge) {
    var _iterator3 = _createForOfIteratorHelper(merged),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var fieldDef1 = _step3.value;

        // If already exists, no need to append to merged array
        if (deepEqual(fieldDef1, fdToMerge)) {
          return;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    merged.push(fdToMerge);
  });
  return merged;
}
export function mergeTitle(title1, title2) {
  if (deepEqual(title1, title2) || !title2) {
    // if titles are the same or title2 is falsy
    return title1;
  } else if (!title1) {
    // if title1 is falsy
    return title2;
  } else {
    return [].concat(_toConsumableArray(array(title1)), _toConsumableArray(array(title2))).join(', ');
  }
}
export function mergeTitleComponent(v1, v2) {
  var v1Val = v1.value;
  var v2Val = v2.value;

  if (v1Val == null || v2Val === null) {
    return {
      explicit: v1.explicit,
      value: null
    };
  } else if ((isText(v1Val) || isSignalRef(v1Val)) && (isText(v2Val) || isSignalRef(v2Val))) {
    return {
      explicit: v1.explicit,
      value: mergeTitle(v1Val, v2Val)
    };
  } else if (isText(v1Val) || isSignalRef(v1Val)) {
    return {
      explicit: v1.explicit,
      value: v1Val
    };
  } else if (isText(v2Val) || isSignalRef(v2Val)) {
    return {
      explicit: v1.explicit,
      value: v2Val
    };
  } else if (!isText(v1Val) && !isSignalRef(v1Val) && !isText(v2Val) && !isSignalRef(v2Val)) {
    return {
      explicit: v1.explicit,
      value: mergeTitleFieldDefs(v1Val, v2Val)
    };
  }
  /* istanbul ignore next: Condition should not happen -- only for warning in development. */


  throw new Error('It should never reach here');
}